import PropTypes from 'prop-types'
import { useState } from 'react'
import { UseI18n } from '../../common/hooks/useI18n'
import { UseTheme } from '../../common/hooks/useTheme'
import { UseTypeFontSize } from '../../common/hooks/useTypeFontSize'
import { getStyle } from '../../common/html/helper'
import { Icon } from '../../common/html/icon'
import { MAX_INPUT_LENGTH, REGEXP_CHARACTERS_BLOCK } from '../constant'
import classes from './InputCompany.module.scss'

export const InputCompany = ({
  containerStyle,
  inputRef,
  placeHolder,
  style,
  type,
  onBlur,
  onChange,
  onClick,
  onEnter,
  isSearch,
  defaultValue,
  isRemoveSpecialCharacters,
  valueAfterOnChange,
  isSelect,
  min,
  max,
  handleOnFocus,
  isFilter,
  isClear,
  handleClear,
  ...props
}) => {
  const typeFontSize = UseTypeFontSize()
  const theme = UseTheme()

  const [borderColor, setBorderColor] = useState('#E0E0E0')

  const onHandleClick = (event) => {
    setBorderColor('#2C73E8')
    onClick(event)
  }

  const onHandleBlur = (event) => {
    setBorderColor('#E0E0E0')
    onBlur(event)
  }

  const onHandleChange = (event) => {
    if (isRemoveSpecialCharacters) {
      onChange(removeSpecials(event.target.value))
    } else if (min || max) {
      let numInput = event.target.value
      if (numInput >= min && numInput <= max) {
        onChange(event.target.value)
      }
    } else {
      onChange(event.target.value)
    }
  }

  const onClearValueSelect = () => {
    onChange('')
    handleClear && handleClear()
  }

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      onEnter(event.target.value)
    }
  }

  const formatValue = () => {
    return defaultValue
  }

  const removeSpecials = (value) =>
    value
      .slice(0, MAX_INPUT_LENGTH)
      .split('')
      .filter((item) => !REGEXP_CHARACTERS_BLOCK.includes(item))
      .join('')

  return (
    <div ref={inputRef} className={classes.container} style={containerStyle}>
      <input
        placeholder={UseI18n(placeHolder)}
        onClick={onHandleClick}
        onBlur={onHandleBlur}
        value={formatValue()}
        onChange={onHandleChange}
        onKeyDown={handleKeyDown}
        onFocus={(e) => {
          handleOnFocus && handleOnFocus()
          e.target.select()
        }}
        style={getStyle(
          {
            fontSize: 14,
            paddingLeft: isSearch || isFilter ? '36px' : '12px',
            borderColor,
            ...style,
          },
          theme,
          typeFontSize,
        )}
        type={type}
        autoComplete="off"
        {...props}
      />
      {isSearch && (
        <Icon
          className={['icon-search', classes.iconSearch].join(' ')}
          style={{ color: '#9C9C9C' }}
        />
      )}
      {isSelect && (
        <Icon
          className={['icon-caret-bottom', classes.iconBottom].join(' ')}
          style={{ color: '#3A414B', fontSize: 8 }}
        />
      )}
      {isFilter && (
        <Icon
          className={['icon-filter', classes.iconFilter].join(' ')}
          style={{ color: '#9C9C9C' }}
        />
      )}
      {isClear && (
        <Icon
          onClick={onClearValueSelect}
          className={['icon-delete', classes.iconClose].join(' ')}
          style={{ color: '#9C9C9C' }}
        />
      )}
    </div>
  )
}

InputCompany.propTypes = {
  ref: PropTypes.object,
  placeHolder: PropTypes.string,
  style: PropTypes.object,
  type: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  isSearch: PropTypes.bool,
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onEnter: PropTypes.func,
  isRemoveSpecialCharacters: PropTypes.bool,
  isSelect: PropTypes.bool,
  handleOnFocus: PropTypes.func,
}

InputCompany.defaultProps = {
  placeHolder: '',
  style: {},
  type: 'text',
  onBlur: () => {},
  onChange: () => {},
  onClick: () => {},
  onEnter: () => {},
  isSearch: false,
  defaultValue: '',
  isRemoveSpecialCharacters: false,
  isSelect: false,
}
